// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T18:12:31.142Z
// Property: Acacia Park (ID: 6767906449167164)
// Collections: 18 amenities, 4 floorplans (live), 21 photos, 75 POIs, 1 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167164",
  "property_external_id": "1089873",
  "property_zillow_url": "https://www.zillow.com/apartments/odessa-tx/acacia-park/5XhxT2/",
  "property_apartments_url": "https://www.apartments.com/acacia-park-odessa-tx/m4f2shk/",
  "property_google_business_url": "https://www.google.com/maps/place/Acacia+Park/data=!4m2!3m1!1s0x0:0xdc6e5408f60d8f04?sa=X&ved=2ahUKEwiovu_v4oOTAxVmSDABHVUsCWIQ_BJ6BAgQEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47606143147",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "acacia-park",
  "property_name": "Acacia Park",
  "property_website_url": "http://texas.weidner.com/apartments/tx/odessa/acacia-park-0/default.aspx",
  "property_domain": "https://www.acaciaparkapartmenthomes.com",
  "property_address": "4775 Oakwood Dr",
  "property_full_address": "4775 Oakwood Dr, Odessa, TX 79761",
  "property_address_1": "4775 Oakwood Dr",
  "property_address_2": null,
  "property_address_city": "Odessa",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79761",
  "property_address_country": "US",
  "property_address_county": "Ector County",
  "property_neighborhood_address": "Midland & Odessa",
  "property_address_latitude": "31.87853585829015",
  "property_address_longitude": "-102.3223631073889",
  "property_email": "acaciapark@weidner.com",
  "property_phone": "4322872047",
  "property_call_tracking_phone": "432-218-3063",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Acacia Park in Odessa, TX, where modern living meets comfort. Choose from stylish one and two-bedroom floor plans featuring granite countertops and walk-in closets. Enjoy our inviting clubhouse, refreshing outdoor pool, and serene community courtyard. Your ideal home awaits—check availability or schedule a tour today!",
  "property_long_description": "Welcome to Acacia Park, Odessa’s premier apartment community where comfort meets style! With a variety of thoughtfully designed floor plans, including spacious one and two-bedroom apartments, we cater to diverse living needs. Each home is equipped with elegant granite kitchen counter-tops, modern amenities such as central AC and heating, and unique features like built-in bookshelves and office desks, ensuring that your living space is as functional as it is beautiful.\n\nEnjoy the perks of a vibrant community with our exceptional property amenities. Take a dip in the stunning outdoor pool, relax at our welcoming clubhouse, or unwind in the tranquil community courtyard. Our dedicated on-site management and maintenance teams are committed to providing a hassle-free living experience, with 24-hour emergency maintenance services for your peace of mind.\n\nAt Acacia Park, we ensure every apartment feels like home with conveniences like walk-in closets and private patios or balconies, perfect for enjoying the beautiful Odessa sunsets. Plus, the additional dining room options offer the ideal space for gatherings or quiet dinners at home.\n\nDiscover the lifestyle of your dreams at Acacia Park. Explore our availability online or schedule a personalized tour today to see why our community is the ideal choice for your next home. Your perfect apartment awaits—let’s make Acacia Park your new haven in Odessa, TX!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021b-887a-7159-a873-af1894cda3cd.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a poolside building under a blue sky.",
    "public_id": "019d021b-887a-7159-a873-af1894cda3cd",
    "storage_key": "property/6767906449167164/019d021b-887a-7159-a873-af1894cda3cd.webp",
    "width": 1024,
    "height": 683
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "200",
  "property_year_built": "1977",
  "property_year_renovated": null,
  "property_walk_score": "51",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400-450",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/acacia-park-0/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafe.com/residentservices/acacia-park-0/userlogin.aspx",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/acacia-park-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d982-f157-76f3-b470-95192784ef42.webp",
  "property_primary_logo_media": {
    "alt_text": "Acacia Park Residences logo",
    "public_id": "01a0d982-f157-76f3-b470-95192784ef42",
    "storage_key": "property/6767906449167164/01a0d982-f157-76f3-b470-95192784ef42.webp",
    "width": 181,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d983-3900-748d-a2d4-bb106cab8e30.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0d983-3900-748d-a2d4-bb106cab8e30",
    "storage_key": "property/6767906449167164/01a0d983-3900-748d-a2d4-bb106cab8e30.webp",
    "width": 181,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d983-2d78-73cb-ad73-c42640520cc8.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0d983-2d78-73cb-ad73-c42640520cc8",
    "storage_key": "property/6767906449167164/01a0d983-2d78-73cb-ad73-c42640520cc8.webp",
    "width": 181,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#a18e58",
  "property_secondary_color": "#543225",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#e8edcd",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 867",
  "property_sqft_min": "530",
  "property_sqft_max": "867",
  "property_price_range": "775 - 1325",
  "property_price_min": "775",
  "property_price_max": "1325",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/AcaciaParkApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/weidnerapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ9zRK4ufO-4YRBI8N9ghUbtw",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Acacia Park",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Home Today",
  "property_home_amenities_blurb": "Welcome to Acacia Park in Odessa, TX, where comfort meets style. Choose from spacious one- and two-bedroom floor plans, complete with granite countertops and walk-in closets. Enjoy community amenities like a sparkling outdoor pool and tranquil courtyard, all managed with care for your convenience—making every day a delight.",
  "property_home_floorplans_blurb": "Welcome to Acacia Park in Odessa, TX, where modern living meets comfort. Choose from a variety of thoughtfully designed floor plans tailored to your lifestyle. Your ideal apartment home awaits—browse our selection today and embrace a vibrant community that feels just right for you!",
  "property_home_gallery_blurb": "At Acacia Park in Odessa, TX, envision a lifestyle of comfort with spacious one- and two-bedroom apartments. Enjoy granite countertops, walk-in closets, and serene patios. Our amenities, including a refreshing outdoor pool and vibrant clubhouse, create the perfect balance of relaxation and community. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Embrace the vibrant lifestyle at Acacia Park in Odessa, TX, where artistic adventures at the Ellen Noël Art Museum blend seamlessly with outdoor fun at McKinney Park and Ratliff Ranch Golf Links. Enjoy the convenience of nearby educational institutions and fitness centers, all within arm's reach of your new home.",
  "property_home_reviews_blurb": "At Acacia Park in Odessa, TX, residents rave about their vibrant community experience, highlighting it as \"a welcoming home with friendly neighbors.\" Join a place where comfort meets camaraderie, and immerse yourself in a lifestyle that feels just right. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the vibrant heart of Odessa, Acacia Park offers unrivaled access to cultural and recreational treasures. Enjoy a day at the Ellen Noël Art Museum or a thrilling visit to Urban Air Trampoline and Adventure Park. With top-tier educational institutions and parks nearby, life here is both enriching and exciting.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Acacia Park, Odessa’s premier apartment community, you'll find inviting one and two-bedroom floor plans tailored for modern living. Enjoy exceptional amenities like a vibrant clubhouse, refreshing outdoor pool, and beautifully landscaped courtyard, all designed to elevate your lifestyle. Your perfect home is waiting—why not take a peek?",
  "property_applynow_blurb": "At Acacia Park in Odessa, TX, your ideal home awaits! Choose from spacious one and two-bedroom layouts featuring gourmet granite kitchens, walk-in closets, and relaxing patios. Enjoy vibrant amenities like the clubhouse and outdoor pool. Ready to elevate your lifestyle? Secure your dream apartment and lease online today!",
  "property_contactus_blurb": "At Acacia Park in Odessa, TX, choose from inviting one and two-bedroom floor plans designed for your lifestyle. Each space combines comfort with contemporary design, fostering a welcoming atmosphere. Have questions? Contact our leasing team today and let us help you find your perfect home at Acacia Park!",
  "property_faqs_blurb": "Welcome to Acacia Park, where comfort meets style in Odessa, TX. With spacious one- and two-bedroom floor plans designed to fit your lifestyle, we offer a welcoming community. Got questions? Head to our FAQs page for quick answers and insights about making Acacia Park your next home sweet home!",
  "property_floorplans_blurb": "At Acacia Park in Odessa, TX, your ideal living space awaits. With thoughtfully designed one and two-bedroom floor plans, each apartment offers the perfect blend of comfort and style. Browse our available homes and envision the lifestyle that suits you best in our vibrant community.",
  "property_gallery_blurb": "At Acacia Park in Odessa, TX, envision life in our stylish one and two-bedroom apartments featuring granite kitchen countertops, walk-in closets, and serene patios. With a vibrant clubhouse, an inviting outdoor pool, and beautifully landscaped courtyards, every day feels like a getaway. Picture yourself living here!",
  "property_interactivemap_blurb": "At Acacia Park in Odessa, TX, find your perfect sanctuary among our thoughtfully designed one and two-bedroom floor plans. Enjoy modern amenities like granite countertops, walk-in closets, and a refreshing outdoor pool. Use our interactive community map to browse available apartments and step into your new lifestyle today!",
  "property_pets_blurb": "Nestled in the heart of Odessa, TX, Acacia Park invites you to enjoy spacious living with your furry companions. With no weight limit and a generous pet policy, your cats and dogs can feel right at home while you indulge in our vibrant community amenities. Experience the perfect blend of comfort and convenience today!",
  "property_referafriend_blurb": "At Acacia Park in Odessa, TX, we believe great friends make great neighbors. With our inviting one and two-bedroom floor plans, your perfect home awaits. Share the joy of community living—refer a friend today and enjoy shared moments in our vibrant neighborhood.",
  "property_residentaccess_blurb": "Welcome to Acacia Park in Odessa, TX, where your comfort meets convenience! Enjoy spacious one and two-bedroom floor plans tailored to your lifestyle. Log in to your resident portal now to effortlessly pay rent, schedule maintenance, and unlock a seamless living experience. Your new home awaits!",
  "property_reviews_blurb": "At Acacia Park in Odessa, TX, our residents love calling this community home! One happy tenant raves, “The staff is always friendly and accommodating, making life here a joy.” See what our residents have to say about living at our vibrant community and discover the exceptional life waiting for you!",
  "property_created_at": "1771535232067",
  "property_scheduletour_blurb": "At Acacia Park in Odessa, TX, your dream home awaits! Choose from spacious one-bedroom and two-bedroom floor plans designed for comfort and style. Ready to see what makes our community special? Schedule a tour today and hear firsthand from our happy residents about their experiences at Acacia Park!",
  "property_thankyou_blurb": "Thank you for your interest in Acacia Park, where modern living meets comfort in Odessa, TX. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. A member of our team will be in touch soon to assist you in finding your perfect home!",
  "property_virtualtours_blurb": "Welcome to Acacia Park in Odessa, TX, where modern living meets comfort. Choose from stylish one and two bedroom floor plans tailored to your lifestyle. Experience the warmth of our community from the comfort of your home—take a virtual tour today and envision your new life with us!",
  "property_copyright": "2026 All Rights Reserved. Acacia Park",
  "property_seo_title_home": "Acacia Park |  Apartments in Odessa, TX",
  "property_seo_description_home": "Make Acacia Park your home in Odessa, TX! Enjoy stylish one and two-bedroom apartments, modern amenities, and a vibrant community. Your oasis awaits!",
  "property_seo_title_floorplans": "Floor Plans | Odessa, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Acacia Park in Odessa, TX! Choose from stylish one or two-bedroom floor plans designed for comfort and convenience.",
  "property_seo_title_amenities": "Amenities | Odessa, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Acacia Park, Odessa, TX! Relax by the pool, unwind in the clubhouse, or enjoy stylish apartments with granite counters.",
  "property_seo_title_gallery": "Gallery | Apartments in Odessa, TX",
  "property_seo_description_gallery": "Picture yourself at Acacia Park in Odessa, TX! Stunning apartments with modern amenities, inviting spaces, and a refreshing outdoor pool await you.",
  "property_seo_title_virtualtours": "Virtual Tours | Acacia Park Apartments",
  "property_seo_description_virtualtours": "Step into Acacia Park in Odessa, TX! Experience spacious one and two-bedroom apartments through our virtual tour—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Acacia Park Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Acacia Park, Odessa, TX! Enjoy modern amenities and spacious floor plans—explore with our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Odessa, TX",
  "property_seo_description_neighborhood": "Experience the charm of Odessa at Acacia Park! Uncover local gems, dining, and attractions just steps from our vibrant community. Your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | Acacia Park",
  "property_seo_description_contact": "Connect with Acacia Park in Odessa, TX. Whether it's a cozy one-bedroom or spacious two-bedroom, our leasing team is ready to assist you—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Odessa, TX",
  "property_seo_description_faqs": "Find quick answers to your FAQs at Acacia Park in Odessa, TX. Explore our spacious floor plans, vibrant amenities, and welcoming community today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Odessa, TX",
  "property_seo_description_reviews": "Join the Acacia Park family in Odessa, TX! Our residents love the spacious floor plans and top-notch amenities. See their reviews and find your perfect home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Odessa, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Acacia Park in Odessa, TX! Choose from spacious 1 & 2-bedroom options with top-notch amenities. Lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Acacia Park",
  "property_seo_description_residentaccess": "Log in to Acacia Park's resident portal for easy rent payments, maintenance requests, and community updates in Odessa, TX. Your home, your convenience!",
  "property_seo_title_referafriend": "Refer A Friend | Acacia Park",
  "property_seo_description_referafriend": "Refer a friend to Acacia Park in Odessa, TX! Unite great friends and great neighbors for a vibrant community that feels like home. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Acacia Park",
  "property_seo_description_scheduletour": "Experience the charm of Acacia Park in Odessa, TX. Your perfect home awaits—schedule a tour today and envision your vibrant new lifestyle with us!",
  "property_seo_title_privacy": "Privacy Policy | Acacia Park",
  "property_seo_description_privacy": "At Acacia Park in Odessa, TX, your privacy matters. Uncover how we protect your personal information. Review our privacy policy for peace of mind today.",
  "property_seo_title_accessibility": "Website Accessibility | Acacia Park",
  "property_seo_description_accessibility": "Enhancing digital access for all, Acacia Park in Odessa, TX, prioritizes inclusivity and seamless online experiences. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Acacia Park",
  "property_seo_description_sitemap": "Uncover the essence of Acacia Park in Odessa, TX! Navigate our sitemap for a seamless journey through our vibrant community and find your perfect apartment.",
  "property_seo_title_thankyou": "Thank You | Acacia Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Acacia Park in Odessa! We’ll be in touch soon to help you find your perfect home in our vibrant community. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Odessa, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793045572168",
  "amenities": [
    {
      "id": "ec_26f9296389d0bf46e608c620",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "129173227",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c13d92a85e7c2abdfb38782",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352741",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-facd-751b-a990-2a832ace0f48.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "019d0219-facd-751b-a990-2a832ace0f48",
        "storage_key": "property/6767906449167164/019d0219-facd-751b-a990-2a832ace0f48.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9dbc49ab7913425dbf679f0c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87390123",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d9a32-492e-722c-ad22-ec016fa5fa30.webp",
      "amenity_image_media": {
        "alt_text": "Lobby area with seating, plants, and office desks.",
        "public_id": "019d9a32-492e-722c-ad22-ec016fa5fa30",
        "storage_key": "property/6767906449167164/019d9a32-492e-722c-ad22-ec016fa5fa30.webp",
        "width": 1024,
        "height": 682
      },
      "amenity_image_alt_text": ",",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d703db02061a89f43103cec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352740",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-1906-7155-af24-28e9c8ba00f4.webp",
      "amenity_image_media": {
        "alt_text": "Apartment buildings and a grassy courtyard with benches and trees under a blue sky.",
        "public_id": "019d021a-1906-7155-af24-28e9c8ba00f4",
        "storage_key": "property/6767906449167164/019d021a-1906-7155-af24-28e9c8ba00f4.webp",
        "width": 1025,
        "height": 682
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6ec0026072305110c9d6f2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352738",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1039f61514d28d3b1919eba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352739",
      "title": "Laundry Facilities/Laundry Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70d03d8f160be90e8cb2f130",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87390125",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d81efdd2af6fee0fe20db5d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87390124",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24e78c0878a42d7bd6eeb4f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87400287",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c306bb46ca973c9a2d98c88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "88164528",
      "title": "Teacher's Discount",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24c39582384ace28c23696b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "124799856",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c25c4853d4cf5eefc47243e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352747",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d9a32-4920-74cf-9d59-f6047cc43049.webp",
      "amenity_image_media": {
        "alt_text": "Apartment buildings with balconies and a sidewalk.",
        "public_id": "019d9a32-4920-74cf-9d59-f6047cc43049",
        "storage_key": "property/6767906449167164/019d9a32-4920-74cf-9d59-f6047cc43049.webp",
        "width": 1024,
        "height": 768
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12c9031aeed7993b178c992f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352745",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f46285388bfdda937c5d5280",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352751",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7eedd4776ecbe3c857ee6875",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352742",
      "title": "Granite Kitchen Counter-tops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-0e55-77a8-a69c-b394654a0305.webp",
      "amenity_image_media": {
        "alt_text": "View of a kitchen and living area, featuring a granite countertop, sink, fruit bowl, and a living room with a sofa and sliding glass doors.",
        "public_id": "019d021a-0e55-77a8-a69c-b394654a0305",
        "storage_key": "property/6767906449167164/019d021a-0e55-77a8-a69c-b394654a0305.webp",
        "width": 1024,
        "height": 682
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_725396604255b9ef2b23a81f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352748",
      "title": "Built-In Bookshelves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02ef6da98c32f62dcb7b4646",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352749",
      "title": "Built-In Office/Desk*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d9cf02ed37fb8571a13affb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "yardi",
      "external_id": "87352750",
      "title": "Dining Room*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_05ffcb56c749838952de0609",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ddbc-76ad-8524-8dc214851f8a.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019d0219-ddbc-76ad-8524-8dc214851f8a",
        "storage_key": "property/6767906449167164/019d0219-ddbc-76ad-8524-8dc214851f8a.webp",
        "width": 1025,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, a stylish coffee table, and a television, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (1).jpg"
    },
    {
      "id": "ec_dfb8ffd9a594decfa3f4b837",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ddb4-7443-b5aa-1eaa9fa3a987.webp",
      "image_media": {
        "alt_text": "Get up to one month free on select homes plus special rates.",
        "public_id": "019d0219-ddb4-7443-b5aa-1eaa9fa3a987",
        "storage_key": "property/6767906449167164/019d0219-ddb4-7443-b5aa-1eaa9fa3a987.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Limited-time offer: Receive up to one month free on select homes and special rates. Restrictions apply. Contact the leasing office for details.",
      "link": "false",
      "alt_text": "Get up to one month free on select homes plus special rates.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Specials (2547).png"
    },
    {
      "id": "ec_2e914f97184b47ae6b1b4152",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-de58-735b-8936-31b236d26204.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, wooden cabinets, black appliances including a refrigerator, microwave, and stove.",
        "public_id": "019d0219-de58-735b-8936-31b236d26204",
        "storage_key": "property/6767906449167164/019d0219-de58-735b-8936-31b236d26204.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring granite countertops, ample wooden cabinetry, and a full suite of black appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, wooden cabinets, black appliances including a refrigerator, microwave, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (2).jpg"
    },
    {
      "id": "ec_e1e842330f720a49c3aec0a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ddba-7519-adf1-af9b1f992a94.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment.",
        "public_id": "019d0219-ddba-7519-adf1-af9b1f992a94",
        "storage_key": "property/6767906449167164/019d0219-ddba-7519-adf1-af9b1f992a94.webp",
        "width": 1025,
        "height": 683
      },
      "title": "Apartment",
      "description": "Comfortable living room with a sofa and coffee table, adjacent to a kitchen and dining area.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (3).jpg"
    },
    {
      "id": "ec_a3b684d08237e923a235f69f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ebc2-717a-b38a-c8b1b6869dd2.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, black appliances, and hardwood floors.",
        "public_id": "019d0219-ebc2-717a-b38a-c8b1b6869dd2",
        "storage_key": "property/6767906449167164/019d0219-ebc2-717a-b38a-c8b1b6869dd2.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "This apartment kitchen features warm wooden cabinets, granite countertops, and modern black appliances, complemented by elegant hardwood floors.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, black appliances, and hardwood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (4).jpg"
    },
    {
      "id": "ec_bb934fc678ebce0f37812e2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ebc6-75de-8ec3-5a5974150e0c.webp",
      "image_media": {
        "alt_text": "Comfortable bedroom with a queen-size bed, nightstands, and a dresser.",
        "public_id": "019d0219-ebc6-75de-8ec3-5a5974150e0c",
        "storage_key": "property/6767906449167164/019d0219-ebc6-75de-8ec3-5a5974150e0c.webp",
        "width": 1025,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in this cozy bedroom, featuring a queen-size bed with plush bedding, two elegant nightstands, and a spacious dresser.",
      "link": "false",
      "alt_text": "Comfortable bedroom with a queen-size bed, nightstands, and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (5).jpg"
    },
    {
      "id": "ec_4dfedb598458a7d369dbf59b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-edef-76eb-8203-eb8b88ce687e.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop and a large mirror, walk-in shower, and toilet.",
        "public_id": "019d0219-edef-76eb-8203-eb8b88ce687e",
        "storage_key": "property/6767906449167164/019d0219-edef-76eb-8203-eb8b88ce687e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with granite countertops, a large mirror, and a walk-in shower with a bathtub.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop and a large mirror, walk-in shower, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (6).jpg"
    },
    {
      "id": "ec_ad3440cd029cbbcd41f2f8f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-efa9-70b7-8358-f1853d362914.webp",
      "image_media": {
        "alt_text": "Community lounge area with comfortable seating, coffee table, and dining area.",
        "public_id": "019d0219-efa9-70b7-8358-f1853d362914",
        "storage_key": "property/6767906449167164/019d0219-efa9-70b7-8358-f1853d362914.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, perfect for socializing or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "Community lounge area with comfortable seating, coffee table, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (7).jpg"
    },
    {
      "id": "ec_ff501166f73a23e4d2025df0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-f823-72ee-bdba-9cb4590f5872.webp",
      "image_media": {
        "alt_text": "Clubhouse lobby with seating area and conference table.",
        "public_id": "019d0219-f823-72ee-bdba-9cb4590f5872",
        "storage_key": "property/6767906449167164/019d0219-f823-72ee-bdba-9cb4590f5872.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and socialize in our welcoming clubhouse lobby, featuring comfortable seating and a conference table for work or meetings.",
      "link": "false",
      "alt_text": "Clubhouse lobby with seating area and conference table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (8).jpg"
    },
    {
      "id": "ec_d407b4d93e72088e9dd6b0b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-facd-751b-a990-2a832ace0f48.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "019d0219-facd-751b-a990-2a832ace0f48",
        "storage_key": "property/6767906449167164/019d0219-facd-751b-a990-2a832ace0f48.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a beautiful courtyard setting.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (9).jpg"
    },
    {
      "id": "ec_214f4b637ce7dd0786fe7dbf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-fb4a-72ee-a492-e37d4c5ae2df.webp",
      "image_media": {
        "alt_text": "Community courtyard with benches and landscaping.",
        "public_id": "019d0219-fb4a-72ee-a492-e37d4c5ae2df",
        "storage_key": "property/6767906449167164/019d0219-fb4a-72ee-a492-e37d4c5ae2df.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Enjoy the fresh air and scenic views from the communal courtyard, complete with comfortable seating and lush greenery.",
      "link": "false",
      "alt_text": "Community courtyard with benches and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (10).jpg"
    },
    {
      "id": "ec_833f94db67e30573c747171c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-fc7f-7063-bc4c-2379fcb5a45b.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building entrance and facade at dusk.",
        "public_id": "019d0219-fc7f-7063-bc4c-2379fcb5a45b",
        "storage_key": "property/6767906449167164/019d0219-fc7f-7063-bc4c-2379fcb5a45b.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building at dusk, showcasing the entrance, balconies, and architectural details.",
      "link": "false",
      "alt_text": "Exterior view of the apartment building entrance and facade at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (11).jpg"
    },
    {
      "id": "ec_496562ba232d593a7b68b5cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-04d2-702c-b5aa-ceda9f34340a.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with parking lot and large tree.",
        "public_id": "019d021a-04d2-702c-b5aa-ceda9f34340a",
        "storage_key": "property/6767906449167164/019d021a-04d2-702c-b5aa-ceda9f34340a.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing the parking area, a large mature tree, and manicured landscaping. A pleasant daytime scene.",
      "link": "false",
      "alt_text": "Exterior of apartment building with parking lot and large tree.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (12).jpg"
    },
    {
      "id": "ec_776454828ed54bf44fd0a1a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-0689-77df-8920-3b4956aa8eb1.webp",
      "image_media": {
        "alt_text": "Acacia Park Apartment Homes monument sign with building in background.",
        "public_id": "019d021a-0689-77df-8920-3b4956aa8eb1",
        "storage_key": "property/6767906449167164/019d021a-0689-77df-8920-3b4956aa8eb1.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to Acacia Park Apartment Homes, featuring beautiful landscaping and a prominent monument sign.",
      "link": "false",
      "alt_text": "Acacia Park Apartment Homes monument sign with building in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Park_Favorites (13).jpg"
    },
    {
      "id": "ec_89615f02c47e78a97c0646c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-06a6-70da-a9fb-3eacb89bf3a2.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d021a-06a6-70da-a9fb-3eacb89bf3a2",
        "storage_key": "property/6767906449167164/019d021a-06a6-70da-a9fb-3eacb89bf3a2.webp",
        "width": 1019,
        "height": 677
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring light wood cabinetry, elegant granite countertops, and sleek black appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, granite countertops, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Favorites (14).jpg"
    },
    {
      "id": "ec_13f1653eebb10e37c8ad405b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-0e55-77a8-a69c-b394654a0305.webp",
      "image_media": {
        "alt_text": "View of a kitchen and living area, featuring a granite countertop, sink, fruit bowl, and a living room with a sofa and sliding glass doors.",
        "public_id": "019d021a-0e55-77a8-a69c-b394654a0305",
        "storage_key": "property/6767906449167164/019d021a-0e55-77a8-a69c-b394654a0305.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Apartment",
      "description": "Discover the comfortable living spaces of our apartments, featuring a well-equipped kitchen and an inviting living area. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "View of a kitchen and living area, featuring a granite countertop, sink, fruit bowl, and a living room with a sofa and sliding glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Favorites (15).jpg"
    },
    {
      "id": "ec_803f1376181225b7941158c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ddbc-76ad-8524-8dc214851f8a.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019d0219-ddbc-76ad-8524-8dc214851f8a",
        "storage_key": "property/6767906449167164/019d0219-ddbc-76ad-8524-8dc214851f8a.webp",
        "width": 1025,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, a stylish coffee table, and a television, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Favorites (16).jpg"
    },
    {
      "id": "ec_5b1db70876bb57571020ae8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-119e-739f-8289-0d2cdaf3f57b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a white sofa, coffee table, TV, and wooden cabinets.",
        "public_id": "019d021a-119e-739f-8289-0d2cdaf3f57b",
        "storage_key": "property/6767906449167164/019d021a-119e-739f-8289-0d2cdaf3f57b.webp",
        "width": 1025,
        "height": 682
      },
      "title": "Apartment",
      "description": "Spacious living room flows into a well-equipped kitchen, perfect for entertaining. Enjoy comfortable seating and modern amenities.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment with a white sofa, coffee table, TV, and wooden cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Favorites (17).jpg"
    },
    {
      "id": "ec_a194ca72be8d44318dd6e617",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-11c8-715f-ac57-517943e090ef.webp",
      "image_media": {
        "alt_text": "Business center with two computers and chairs",
        "public_id": "019d021a-11c8-715f-ac57-517943e090ef",
        "storage_key": "property/6767906449167164/019d021a-11c8-715f-ac57-517943e090ef.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Stay productive in our community business center, equipped with computers and internet access.",
      "link": "false",
      "alt_text": "Business center with two computers and chairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Favorites (18).jpg"
    },
    {
      "id": "ec_c323c6ed00a2420c144677b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-176a-77d8-9d37-853132775783.webp",
      "image_media": {
        "alt_text": "Lobby seating area with chairs and a coffee table, overlooking the pool.",
        "public_id": "019d021a-176a-77d8-9d37-853132775783",
        "storage_key": "property/6767906449167164/019d021a-176a-77d8-9d37-853132775783.webp",
        "width": 1022,
        "height": 682
      },
      "title": "Community",
      "description": "Relax in our comfortable lobby seating area, complete with a coffee table, perfect for socializing or unwinding. Enjoy views of the sparkling outdoor pool through the large windows.",
      "link": "false",
      "alt_text": "Lobby seating area with chairs and a coffee table, overlooking the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Favorites (19).jpg"
    },
    {
      "id": "ec_2e714d35a8175a02517e559a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-1906-7155-af24-28e9c8ba00f4.webp",
      "image_media": {
        "alt_text": "Apartment buildings and a grassy courtyard with benches and trees under a blue sky.",
        "public_id": "019d021a-1906-7155-af24-28e9c8ba00f4",
        "storage_key": "property/6767906449167164/019d021a-1906-7155-af24-28e9c8ba00f4.webp",
        "width": 1025,
        "height": 682
      },
      "title": "Community",
      "description": "Enjoy the fresh air and scenic views in our beautifully maintained community courtyard, perfect for relaxation and socializing.",
      "link": "false",
      "alt_text": "Apartment buildings and a grassy courtyard with benches and trees under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Acacia_Favorites (20).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e5c79712-05b3-4621-bb61-eded6b6f1825",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Pho House Odessa",
      "poi_type": "Restaurants",
      "poi_address": "1541 John Ben Shepperd Pkwy Unit 2, Odessa, TX 79761, USA",
      "poi_short_description": "Noodle soups, grilled fare, vermicelli,  & other Vietnamese comfort foods with boba & milk teas.",
      "poi_long_description": "Noodle soups, grilled fare, vermicelli,  & other Vietnamese comfort foods with boba & milk teas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-7c6f-7615-b11e-b27541e585fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-7c6f-7615-b11e-b27541e585fd",
        "storage_key": "property/6767906449167164/01a0d98f-7c6f-7615-b11e-b27541e585fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phohousejbs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9388982337017842796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-house-odessa",
      "poi_latitude": "31.8767431",
      "poi_longitude": "-102.3296089",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-667-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUsmvcTO-4YRbIxdyLBdTII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_0c05a4e7-e515-473e-9681-7e7be109eeda",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Sweet Traveler Patisserie",
      "poi_type": "Restaurants",
      "poi_address": "3989 John Ben Shepperd Pkwy, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-842b-77ad-b43e-c96cc6e5ea6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-842b-77ad-b43e-c96cc6e5ea6a",
        "storage_key": "property/6767906449167164/01a0d98f-842b-77ad-b43e-c96cc6e5ea6a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.sweet-traveler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12090392492825203700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-traveler-patisserie",
      "poi_latitude": "31.8900297",
      "poi_longitude": "-102.3335289",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-631-6650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbfm1aDJ-4YR9FPlIeqzyac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_e5d34224-f982-4fc0-ba42-a76675ae2f8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Teak & Charlie's Jersey Girl Pizza",
      "poi_type": "Restaurants",
      "poi_address": "4007 John Ben Shepperd Pkwy, Odessa, TX 79762, USA",
      "poi_short_description": "Joint run by 2 brothers serving smoothies, sandwiches & build-your-own pizzas in a basic space.",
      "poi_long_description": "Joint run by 2 brothers serving smoothies, sandwiches & build-your-own pizzas in a basic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-80bc-7513-9698-35fdfa9ea4a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-80bc-7513-9698-35fdfa9ea4a1",
        "storage_key": "property/6767906449167164/01a0d98f-80bc-7513-9698-35fdfa9ea4a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.foodtecsolutions.com/ordering/teakandcharliesjerseygirlpizza/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=7950400904949067686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teak--charlies-jersey-girl-pizza",
      "poi_latitude": "31.8899414",
      "poi_longitude": "-102.3338597",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-366-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1IjvCfP-4YRpu9uAYB_VW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_1c09eb22-693f-4588-a5eb-a05e9ebb1bd8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Dos Compadres Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4019 John Ben Shepperd Pkwy, Odessa, TX 79762, USA",
      "poi_short_description": "Informal spot dishing up Tex-Mex fare such as fajitas, enchiladas and tacos, plus beer and margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8111-7259-8e61-7f03c09270fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8111-7259-8e61-7f03c09270fa",
        "storage_key": "property/6767906449167164/01a0d98f-8111-7259-8e61-7f03c09270fa.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.doscompadres.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15145394461264539629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dos-compadres-mexican-restaurant",
      "poi_latitude": "31.8902199",
      "poi_longitude": "-102.3343014",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-550-0691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNy3uQN3Y-4YR7W_XzgRAL9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_e5184f60-6159-4616-83cb-729be40120c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Jack Jordan's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "1501 John Ben Shepperd Pkwy #1921, Odessa, TX 79761, USA",
      "poi_short_description": "Comfort food favorite (ribs, brisket, chicken, turkey, sausage, etc.) served in a casual joint, with drive-thru and catering options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8184-778d-bf34-692f6bc6f0d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8184-778d-bf34-692f6bc6f0d4",
        "storage_key": "property/6767906449167164/01a0d98f-8184-778d-bf34-692f6bc6f0d4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://jackjordansbarbque.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091257772201824287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-jordans-bar-b-que",
      "poi_latitude": "31.876173",
      "poi_longitude": "-102.3290718",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-362-7890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQKLZMPO-4YRH1BhCC4Q7Jk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_71e6a55e-3082-432e-ae2c-2d6734990c93",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Ed & Toms Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "317 Martin Luther King, Jr. St, Odessa, TX 79761, USA",
      "poi_short_description": "Barbecue joint dishing up pulled pork, ribs, brisket, and sides in a casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-7d9c-753f-8e14-ee24f84054e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-7d9c-753f-8e14-ee24f84054e2",
        "storage_key": "property/6767906449167164/01a0d98f-7d9c-753f-8e14-ee24f84054e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://edandtomsbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17891799448193113003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ed--toms-bar-b-que",
      "poi_latitude": "31.8431703",
      "poi_longitude": "-102.3616672",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-307-6606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5vA7ljJ-4YRq5sUps1wTPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_efc2dd86-dd30-417e-a6a7-0301f2f0d9da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Campo Azul Mexican Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "2604 N Grandview Ave, Odessa, TX 79761, USA",
      "poi_short_description": "Casual restaurant serving traditional Mexican fare, beer, and cocktails, including breakfast options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-7c27-73ac-bbec-eb40ee6cb46d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-7c27-73ac-bbec-eb40ee6cb46d",
        "storage_key": "property/6767906449167164/01a0d98f-7c27-73ac-bbec-eb40ee6cb46d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://campoazultx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14165656627518556315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campo-azul-mexican-restaurant--bar",
      "poi_latitude": "31.8748634",
      "poi_longitude": "-102.3460408",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-552-8288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6CKj9PP-4YRm8hmXaaFlsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_fc10e137-03e7-4306-983a-890bc716d199",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Taquería Reynosa | Mexican",
      "poi_type": "Restaurants",
      "poi_address": "2701 N Grandview Ave, Odessa, TX 79762, USA",
      "poi_short_description": "Casual restaurant offering tacos, fajitas, and nachos, plus late-night hours.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-816d-766d-9657-3c7fa3190f6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-816d-766d-9657-3c7fa3190f6e",
        "storage_key": "property/6767906449167164/01a0d98f-816d-766d-9657-3c7fa3190f6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.toasttab.com/taqueriareynosa/v3/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751881896122280974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taquera-reynosa--mexican",
      "poi_latitude": "31.8757625",
      "poi_longitude": "-102.3477031",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-272-1056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUFZojLJ-4YRDmyWybRcETQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2cf73d2c-bb42-4698-bcab-27cc1c27e6f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Mi Piaci Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2607 N Grandview Ave, Odessa, TX 79761, USA",
      "poi_short_description": "Long-running, family-operated, BYOB joint providing heaping plates of traditional Italian fare.",
      "poi_long_description": "Long-running, family-operated, BYOB joint providing heaping plates of traditional Italian fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-7cc8-754d-8ee4-982cf834d2df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-7cc8-754d-8ee4-982cf834d2df",
        "storage_key": "property/6767906449167164/01a0d98f-7cc8-754d-8ee4-982cf834d2df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mipiacirestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11982114152141705626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-piaci-italian-restaurant",
      "poi_latitude": "31.874369",
      "poi_longitude": "-102.3482332",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-362-8060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9247jLJ-4YRmlGWYFYFSaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c8467c2c-34ae-4448-835e-cdbea43bc547",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Taste of India - Permian Basin",
      "poi_type": "Restaurants",
      "poi_address": "3001 E Business Loop 20, Odessa, TX 79761, USA",
      "poi_short_description": "Modest restaurant with a buffet offering traditional Indian food staples & veggie options.",
      "poi_long_description": "Modest restaurant with a buffet offering traditional Indian food staples & veggie options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-7d34-70d9-88ac-b33bd9c17ccf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-7d34-70d9-88ac-b33bd9c17ccf",
        "storage_key": "property/6767906449167164/01a0d98f-7d34-70d9-88ac-b33bd9c17ccf.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.tasteofindiapermian.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2613729187228607889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taste-of-india---permian-basin",
      "poi_latitude": "31.8700064",
      "poi_longitude": "-102.3207474",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-332-4973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9en_erO-4YRkeXU_9jURSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_f7ecb2fa-214f-40d0-af4c-d889c81a615d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Curb Side Bistro",
      "poi_type": "Restaurants",
      "poi_address": "3816 Andrews Hwy, Odessa, TX 79762, USA",
      "poi_short_description": "Burgers, pulled pork sandwiches and sliders served at a bistro with a casual vibe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-49b2-7786-9dc3-1d298ee40fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-49b2-7786-9dc3-1d298ee40fae",
        "storage_key": "property/6767906449167164/019d021a-49b2-7786-9dc3-1d298ee40fae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.facebook.com/CURBSIDEBISTRO2014/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15376544075587571644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "curb-side-bistro",
      "poi_latitude": "31.880592",
      "poi_longitude": "-102.3838418",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-272-0959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuU79qAPJ-4YRvM-ISl51ZNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_04430259-3461-4ae6-9672-1883b266265a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Mamasita's Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "4214 Maple Ave, Odessa, TX 79762, USA",
      "poi_short_description": "Locally owned outpost serving a range of classic Mexican plates & margaritas in a laid-back setting.",
      "poi_long_description": "Locally owned outpost serving a range of classic Mexican plates & margaritas in a laid-back setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8817-719e-b3ff-05b29cf8aae4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8817-719e-b3ff-05b29cf8aae4",
        "storage_key": "property/6767906449167164/01a0d98f-8817-719e-b3ff-05b29cf8aae4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://mamasitasmexicangrilltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14830024171845811898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mamasitas-mexican-grill",
      "poi_latitude": "31.88563",
      "poi_longitude": "-102.338988",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-362-7474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwNJVS3J-4YRun5TVWnUzs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c802793b-964a-48e6-a1c9-7ba3131368a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "The Block Meat Co.",
      "poi_type": "Restaurants",
      "poi_address": "200 E 52nd St, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-a82f-70bb-a5cf-2b743439696c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-a82f-70bb-a5cf-2b743439696c",
        "storage_key": "property/6767906449167164/01a0d98f-a82f-70bb-a5cf-2b743439696c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4275049679686194153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-block-meat-co",
      "poi_latitude": "31.8930807",
      "poi_longitude": "-102.3857017",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-272-0432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXcG8TA7J-4YR6dPXkggHVDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food"
    },
    {
      "id": "custom_b12df51b-f2e6-4f6f-96af-9dde7e125fbb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Permian Basin Hamburger Co",
      "poi_type": "Restaurants",
      "poi_address": "520 N Grant Ave, Odessa, TX 79761, USA",
      "poi_short_description": "No-frills spot offering a limited lunch menu of American comfort foods served at a counter.",
      "poi_long_description": "No-frills spot offering a limited lunch menu of American comfort foods served at a counter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8a65-7629-9bc4-c31b1d1c3592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8a65-7629-9bc4-c31b1d1c3592",
        "storage_key": "property/6767906449167164/01a0d98f-8a65-7629-9bc4-c31b1d1c3592.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5437513223744029803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "permian-basin-hamburger-co",
      "poi_latitude": "31.8491954",
      "poi_longitude": "-102.3699188",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-333-4971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b315-7464-9852-1ce80bdd26dd",
        "storage_key": "property/6767906449167164/019d021a-b315-7464-9852-1ce80bdd26dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-h0hGfJ-4YRa4TAwnftdUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_51432921-e37a-4039-b92d-4f7f002377f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "OXXO",
      "poi_type": "Shopping & Retail",
      "poi_address": "4601 Oakwood Dr, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8b4e-71be-9d39-48084ccd7282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8b4e-71be-9d39-48084ccd7282",
        "storage_key": "property/6767906449167164/01a0d98f-8b4e-71be-9d39-48084ccd7282.webp",
        "width": 1039,
        "height": 585
      },
      "poi_business_url": "https://oxxo-us.com/stores/oxxo-convenience-store-1137-4601-oakwood-drive-odessa-tx-79761/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3440681734492310154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxxo",
      "poi_latitude": "31.8768571",
      "poi_longitude": "-102.3282551",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-263-5841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-bcbb-7557-883d-26cdd367d1ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0d98f-bcbb-7557-883d-26cdd367d1ca",
        "storage_key": "property/6767906449167164/01a0d98f-bcbb-7557-883d-26cdd367d1ca.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ2RaR2CHP-4YRisqW2c7Bvy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_091a7494-2ae0-4072-9c2d-4b9bd558235b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "3801 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-e1d6-773f-8364-827c689690e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-e1d6-773f-8364-827c689690e5",
        "storage_key": "property/6767906449167164/01a0d98d-e1d6-773f-8364-827c689690e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/odessa/42nd-st.-h-e-b-387?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=15246427008090309204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "31.891449",
      "poi_longitude": "-102.351012",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-362-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b317-714e-b57c-83d4b83a14e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b317-714e-b57c-83d4b83a14e1",
        "storage_key": "property/6767906449167164/019d021a-b317-714e-b57c-83d4b83a14e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsQCmQtTI-4YRVAIlt5UwltM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e695ff32-fb47-42e5-a812-5ff4459e9ec1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "4950 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Grocery chain featuring gourmet items and everyday essentials, plus a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8ade-77b8-b434-7d84441d6a15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8ade-77b8-b434-7d84441d6a15",
        "storage_key": "property/6767906449167164/01a0d98f-8ade-77b8-b434-7d84441d6a15.webp",
        "width": 1280,
        "height": 621
      },
      "poi_business_url": "https://local.marketstreetunited.com/tx/odessa/4950-e-42nd-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5585564719479866515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "31.8916515",
      "poi_longitude": "-102.3343903",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-367-4976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b317-714e-b57c-83d4b83a14e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b317-714e-b57c-83d4b83a14e1",
        "storage_key": "property/6767906449167164/019d021a-b317-714e-b57c-83d4b83a14e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4FXKSbP-4YRk0SNzoTpg00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b6d9f2eb-5651-4a67-a479-aacfd8dcbe7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4101 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-b4f4-774e-9d0c-e29541544990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-b4f4-774e-9d0c-e29541544990",
        "storage_key": "property/6767906449167164/01a0d98f-b4f4-774e-9d0c-e29541544990.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/odessa-tx-pharmacies/4101-east-42nd-st-odessa-tx-79762/storeid=5647?WT.mc_id=LS_GOOGLE_RX_5647",
      "poi_directions_map_url": "https://maps.google.com/?cid=5453611555086820177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "31.8924933",
      "poi_longitude": "-102.3413549",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-366-1160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b70c-73e0-82a2-3ed6ac4f01c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b70c-73e0-82a2-3ed6ac4f01c7",
        "storage_key": "property/6767906449167164/019d021a-b70c-73e0-82a2-3ed6ac4f01c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtUCy5yvP-4YRUWPqm9Aer0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_31ea31f3-9219-4f4a-9bb9-e4420e175e37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "3909 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-66c9-725b-9696-4ad9c2c89877.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-66c9-725b-9696-4ad9c2c89877",
        "storage_key": "property/6767906449167164/019d021a-66c9-725b-9696-4ad9c2c89877.webp",
        "width": 1280,
        "height": 906
      },
      "poi_business_url": "https://www.target.com/sl/odessa/1506",
      "poi_directions_map_url": "https://maps.google.com/?cid=1418829755690757497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "31.892559",
      "poi_longitude": "-102.3476404",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-366-0398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b336-742c-9bb9-bde6209fbadc",
        "storage_key": "property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7bALvNTI-4YRea2zQCWysBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7ad48131-acbc-454e-87b1-207d8f28d54e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4210 John Ben Shepperd Pkwy, Odessa, TX 79762, USA",
      "poi_short_description": "Department store stocking a variety of merchandise, including apparel, housewares, electronics, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-60d4-7499-a0b5-43648408a383.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-60d4-7499-a0b5-43648408a383",
        "storage_key": "property/6767906449167164/019d021a-60d4-7499-a0b5-43648408a383.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/537-odessa-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9512536462235812765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "31.8956203",
      "poi_longitude": "-102.3325119",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-363-9663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b336-742c-9bb9-bde6209fbadc",
        "storage_key": "property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq1Vdcl7J-4YRnUOESINRA4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2437f254-7b12-4855-b477-de7c039de2f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "4230 John Ben Shepperd Pkwy, Odessa, TX 79762, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8bfa-758a-b886-085c52fd3ff9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8bfa-758a-b886-085c52fd3ff9",
        "storage_key": "property/6767906449167164/01a0d98f-8bfa-758a-b886-085c52fd3ff9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/6439-odessa-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10558856385395936012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "31.897823",
      "poi_longitude": "-102.3329746",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-550-9191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b336-742c-9bb9-bde6209fbadc",
        "storage_key": "property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgTkncyXP-4YRDMvjdfCXiJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_2956a2e6-763e-42e4-8ad2-f55728090ed0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "5181 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8c6e-70e7-aad4-466612ceaad4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8c6e-70e7-aad4-466612ceaad4",
        "storage_key": "property/6767906449167164/01a0d98f-8c6e-70e7-aad4-466612ceaad4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Odessa/TX/Odessa/79762/562?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12638255856822051033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.8962739",
      "poi_longitude": "-102.3272789",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-368-9118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b336-742c-9bb9-bde6209fbadc",
        "storage_key": "property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoUmrfiHP-4YR2eBgzr0aZK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f21fe49f-ca3e-4651-9195-73ed0722c225",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Music City Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "4101 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Old-school mall since 1980 offering kids' play areas, a food court, movie theater & indoor ice rink.",
      "poi_long_description": "Old-school mall since 1980 offering kids' play areas, a food court, movie theater & indoor ice rink.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-e30a-7569-a75c-570961119865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-e30a-7569-a75c-570961119865",
        "storage_key": "property/6767906449167164/01a0d98d-e30a-7569-a75c-570961119865.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://musiccitymall.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4647290278163924921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "music-city-mall",
      "poi_latitude": "31.8946218",
      "poi_longitude": "-102.3389494",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-550-2483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b336-742c-9bb9-bde6209fbadc",
        "storage_key": "property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPeKT_CvP-4YRuUcWtuJ9fkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1fa48c7e-47c8-475b-b895-8de08edd0739",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Westlake Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "4652 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8e6f-763a-ab5a-cc1fd1015af7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8e6f-763a-ab5a-cc1fd1015af7",
        "storage_key": "property/6767906449167164/01a0d98f-8e6f-763a-ab5a-cc1fd1015af7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.acehardware.com/store-details/03868",
      "poi_directions_map_url": "https://maps.google.com/?cid=9949693777717646772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlake-ace-hardware",
      "poi_latitude": "31.8795372",
      "poi_longitude": "-102.3263693",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-368-7421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b336-742c-9bb9-bde6209fbadc",
        "storage_key": "property/6767906449167164/019d021a-b336-742c-9bb9-bde6209fbadc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1SNmId3O-4YRtFXGbMZpFIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_8fa530d9-2555-46e7-80ca-89798ffadccc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Blanton Elementary School",
      "poi_type": "Education",
      "poi_address": "4101 Lynbrook Ave, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ectorcountyisd.org/Domain/479",
      "poi_directions_map_url": "https://maps.google.com/?cid=3459349081142700684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blanton-elementary-school",
      "poi_latitude": "31.8883863",
      "poi_longitude": "-102.3393184",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-456-1259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9_ln49XO-4YRjKqVL6kTAjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_018a19da-ed9c-434e-8f01-c9084a4ffbcb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Nimitz Middle School",
      "poi_type": "Education",
      "poi_address": "4900 Maple Ave, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://nimitz.ectorcountyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18096568855430299477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nimitz-middle-school",
      "poi_latitude": "31.8867232",
      "poi_longitude": "-102.3335009",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-456-0469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0YNzs9nO-4YRVf9RiX7tI_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5a56103f-e2c0-4023-a470-af7e18ae0efb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Permian High School",
      "poi_type": "Education",
      "poi_address": "1800 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-8e5d-72ee-a36e-3dc7f9d4dd60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-8e5d-72ee-a36e-3dc7f9d4dd60",
        "storage_key": "property/6767906449167164/01a0d98f-8e5d-72ee-a36e-3dc7f9d4dd60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://phs.ectorcountyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13348036601647203159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "permian-high-school",
      "poi_latitude": "31.8865757",
      "poi_longitude": "-102.3578201",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-456-0039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1ws8OdjI-4YRVwMYepHAPbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_36c9b385-b7dc-40c4-8c66-24c8f9f5374c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Odessa College",
      "poi_type": "Education",
      "poi_address": "201 W University Blvd, Odessa, TX 79764, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-e3bb-7268-9eaa-96958bc724b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-e3bb-7268-9eaa-96958bc724b0",
        "storage_key": "property/6767906449167164/01a0d98d-e3bb-7268-9eaa-96958bc724b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.odessa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18132136236883730055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odessa-college",
      "poi_latitude": "31.8657459",
      "poi_longitude": "-102.3837572",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-335-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO65sGg7J-4YRh15x2tZJovs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cdf610a4-8df4-4e6b-8158-08d39955ca44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Austin Montessori",
      "poi_type": "Education",
      "poi_address": "901 N Lee Ave, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ectorcountyisd.org/departments/choice-schools/choice-schools/austin-montessori",
      "poi_directions_map_url": "https://maps.google.com/?cid=17940399406091484468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-montessori",
      "poi_latitude": "31.8511205",
      "poi_longitude": "-102.3743555",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-456-1029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJce4apWjJ-4YRND22IDUa-fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5be5406f-9eaa-4f3d-b755-e3f3f987dd99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Carver Early Education Center",
      "poi_type": "Education",
      "poi_address": "600 College Ave, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://carver.ectorcountyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7134793366440983677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carver-early-education-center",
      "poi_latitude": "31.8439844",
      "poi_longitude": "-102.3525541",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-456-1069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2y-qeVbJ-4YRfTyH2MPgA2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_9b9ba2f3-df02-482f-935f-90509066d25b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Lamar Early Education Center",
      "poi_type": "Education",
      "poi_address": "501 Lettie Lee Ave, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lamar.ectorcountyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9869847080064717653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lamar-early-education-center",
      "poi_latitude": "31.8537598",
      "poi_longitude": "-102.3604666",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-456-1159",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_YxX4ETJ-4YRVROvaqC9-Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_9c5fb42c-8fd6-44b0-ae70-92a2175d43c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Burleson Elementary School",
      "poi_type": "Education",
      "poi_address": "3900 N Golder Ave, Odessa, TX 79764, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://burleson.ectorcountyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7794543936902526138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burleson-elementary-school",
      "poi_latitude": "31.876962",
      "poi_longitude": "-102.3914078",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-456-1369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvygPNQfJ-4YRuvQ_0WnIK2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_527667f2-aed2-4365-9138-9d79fd21bfaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Odessa Christian School",
      "poi_type": "Education",
      "poi_address": "2000 Doran Dr, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-924f-75d6-a760-350b6ba6e719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-924f-75d6-a760-350b6ba6e719",
        "storage_key": "property/6767906449167164/01a0d98f-924f-75d6-a760-350b6ba6e719.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.odessa-christian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2966768285290088538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odessa-christian-school",
      "poi_latitude": "31.8719469",
      "poi_longitude": "-102.3543685",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-362-6311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCQn9GTHJ-4YRWkicbwkULCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0fe6bb4e-34fd-40ca-a43c-80a36dfb1d23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Odessa Family YMCA",
      "poi_type": "Education",
      "poi_address": "3001 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-923d-702b-bf7a-76f06f431294.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-923d-702b-bf7a-76f06f431294",
        "storage_key": "property/6767906449167164/01a0d98f-923d-702b-bf7a-76f06f431294.webp",
        "width": 1280,
        "height": 870
      },
      "poi_business_url": "http://www.odessaymca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4579835687954165678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odessa-family-ymca",
      "poi_latitude": "31.8743317",
      "poi_longitude": "-102.3556842",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-362-4301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGefNRjDJ-4YRri8qDkvYjj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_2758df77-b4fd-494b-97e5-dd531a7b34e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Cinemark Century Odessa 12",
      "poi_type": "Entertainment",
      "poi_address": "4221 Preston Smith Rd, Odessa, TX 79762, USA",
      "poi_short_description": "Traditional movie theater offering 3D movies, stadium seating, and arcade games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9261-7619-aa7e-45bf342d107d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9261-7619-aa7e-45bf342d107d",
        "storage_key": "property/6767906449167164/01a0d98f-9261-7619-aa7e-45bf342d107d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-odessa/cinemark-century-odessa-12?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTI5OTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=894743598113207034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-century-odessa-12",
      "poi_latitude": "31.8973922",
      "poi_longitude": "-102.3275913",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-552-7996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bab6-732d-943c-6f5e4e20c022.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bab6-732d-943c-6f5e4e20c022",
        "storage_key": "property/6767906449167164/019d021a-bab6-732d-943c-6f5e4e20c022.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcNKoiPP-4YR-rKX2o_Eagw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_802d7c84-1450-4756-a504-d38e27987aff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Cinergy Odessa Featuring EPIC",
      "poi_type": "Entertainment",
      "poi_address": "8250 TX-191, Odessa, TX 79765, USA",
      "poi_short_description": "Entertainment venue offering bowling, laser tag, arcade games, and movies, plus on-site dining.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9443-71eb-8a65-783c9eb7f6bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9443-71eb-8a65-783c9eb7f6bb",
        "storage_key": "property/6767906449167164/01a0d98f-9443-71eb-8a65-783c9eb7f6bb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cinergy.com/odessa?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing-odessa",
      "poi_directions_map_url": "https://maps.google.com/?cid=4931360277581517552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinergy-odessa-featuring-epic",
      "poi_latitude": "31.9246274",
      "poi_longitude": "-102.2846484",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-400-2444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bab6-732d-943c-6f5e4e20c022.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bab6-732d-943c-6f5e4e20c022",
        "storage_key": "property/6767906449167164/019d021a-bab6-732d-943c-6f5e4e20c022.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJya1KnpHP-4YR8NK3hAu2b0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_8e153a46-ae75-4bac-a797-c0241cd07e05",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Ector County Coliseum",
      "poi_type": "Entertainment",
      "poi_address": "4201 Andrews Hwy, Odessa, TX 79762, USA",
      "poi_short_description": "Rodeo, monster-truck and hockey competitions, craft fairs and other events in an arena.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-78ab-7730-a2b9-0f5a420b3f67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-78ab-7730-a2b9-0f5a420b3f67",
        "storage_key": "property/6767906449167164/019d021a-78ab-7730-a2b9-0f5a420b3f67.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://ectorcountycoliseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17237335996745968089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ector-county-coliseum",
      "poi_latitude": "31.8838889",
      "poi_longitude": "-102.3875",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-366-3541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJWs5JP7I-4YR2ekYAMNRN-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_ed86b2f3-c982-411f-b3c8-ace4f1524c17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "The Globe of the Great Southwest",
      "poi_type": "Entertainment",
      "poi_address": "2308 Shakespeare Rd, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-95cc-760e-aeea-6038198fc9fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-95cc-760e-aeea-6038198fc9fb",
        "storage_key": "property/6767906449167164/01a0d98f-95cc-760e-aeea-6038198fc9fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17941096346755218675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-globe-of-the-great-southwest",
      "poi_latitude": "31.864229",
      "poi_longitude": "-102.382878",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-335-6818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_ymbDQ3J-4YR8zxnRRKU-_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_f292739d-29dc-4f1f-a82a-367cd3f44d80",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "The Ector Theatre",
      "poi_type": "Entertainment",
      "poi_address": "500 N Texas Ave, Odessa, TX 79761, USA",
      "poi_short_description": "Vintage theater offering live tribute shows, film screenings & training programs in music & acting.",
      "poi_long_description": "Vintage theater offering live tribute shows, film screenings & training programs in music & acting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-96fa-7176-ac19-0e1f6e926af1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-96fa-7176-ac19-0e1f6e926af1",
        "storage_key": "property/6767906449167164/01a0d98f-96fa-7176-ac19-0e1f6e926af1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theector.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3068637815323494553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ector-theatre",
      "poi_latitude": "31.849294",
      "poi_longitude": "-102.3682739",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-653-1246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJndH7dl3J-4YRmQiwrtX9lSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_6002137d-2a6c-46ac-8da3-143e6e36d633",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Permian Basin Petroleum Museum",
      "poi_type": "Entertainment",
      "poi_address": "1500 I-20, Midland, TX 79701, USA",
      "poi_short_description": "Interactive exhibits interpret the history of oil, its geology & the industry's modern roots.",
      "poi_long_description": "Interactive exhibits interpret the history of oil, its geology & the industry's modern roots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9e59-717d-84e1-62229d75e4d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9e59-717d-84e1-62229d75e4d3",
        "storage_key": "property/6767906449167164/01a0d98f-9e59-717d-84e1-62229d75e4d3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://petroleummuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17173222098646240074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "permian-basin-petroleum-museum",
      "poi_latitude": "31.9720665",
      "poi_longitude": "-102.0851728",
      "poi_miles_from_property": "16.9",
      "poi_walking_minutes": "6 hours 8 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 432-683-4403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bab8-7173-b0c1-3551e7553048.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bab8-7173-b0c1-3551e7553048",
        "storage_key": "property/6767906449167164/019d021a-bab8-7173-b0c1-3551e7553048.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSwNsBHY-4YRSouy1oKKU-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3021847c-d17a-45b0-87aa-4bba3212e4cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Wagner Noël Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "1310 Farm to Market 1788, Midland, TX 79707, USA",
      "poi_short_description": "Massive, contemporary performance hall hosting musicians, operas, ballets & headline comedians.",
      "poi_long_description": "Massive, contemporary performance hall hosting musicians, operas, ballets & headline comedians.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9da7-704f-9606-487b151554d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9da7-704f-9606-487b151554d9",
        "storage_key": "property/6767906449167164/01a0d98f-9da7-704f-9606-487b151554d9.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.wagnernoel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7435613550878986471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wagner-nol-performing-arts-center",
      "poi_latitude": "31.9701344",
      "poi_longitude": "-102.2467799",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-552-4430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7csYSO7C-4YR5xA5AyGbMGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_4d75df62-3550-4641-856d-44d973864a09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "4101 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-ecbd-76cb-ba43-b21acf7ed474.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-ecbd-76cb-ba43-b21acf7ed474",
        "storage_key": "property/6767906449167164/01a0d98d-ecbd-76cb-ba43-b21acf7ed474.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.urbanair.com/texas-odessa",
      "poi_directions_map_url": "https://maps.google.com/?cid=4406183542498196917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "31.8951345",
      "poi_longitude": "-102.3376817",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-296-5067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0uxBB7P-4YRtf3GQZboJT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_91e74fc7-23c5-4f00-b280-7c39051ce4f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Rimrock Raceway",
      "poi_type": "Entertainment",
      "poi_address": "12412 W Hwy 80 E, Odessa, TX 79765, USA",
      "poi_short_description": "Karts for birthday parties and individual races on a course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9c43-7609-976b-b8ef649d0de3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9c43-7609-976b-b8ef649d0de3",
        "storage_key": "property/6767906449167164/01a0d98f-9c43-7609-976b-b8ef649d0de3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rimrockkarting.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=329028416151563135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rimrock-raceway",
      "poi_latitude": "31.9071735",
      "poi_longitude": "-102.250589",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-246-5069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3x_wkijQ-4YRfyu56ZnxkAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "go_karting_venue"
    },
    {
      "id": "custom_68c40917-0b13-44a8-8b55-c945da0243c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Parker House Museum",
      "poi_type": "Entertainment",
      "poi_address": "1118 Maple Ave, Odessa, TX 79761, USA",
      "poi_short_description": "Museum-home where early 1900s rancher Jim Parker lived, with period furniture, artifacts & photos.",
      "poi_long_description": "Museum-home where early 1900s rancher Jim Parker lived, with period furniture, artifacts & photos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9ce9-769c-9837-a3b2556ddd3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9ce9-769c-9837-a3b2556ddd3f",
        "storage_key": "property/6767906449167164/01a0d98f-9ce9-769c-9837-a3b2556ddd3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://texaspecostrail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=129195063451440641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parker-house-museum",
      "poi_latitude": "31.8628734",
      "poi_longitude": "-102.3601783",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-335-9918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bab8-7173-b0c1-3551e7553048.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bab8-7173-b0c1-3551e7553048",
        "storage_key": "property/6767906449167164/019d021a-bab8-7173-b0c1-3551e7553048.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJcFRmkfJ-4YRAdbBxzn-ygE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8229d7cc-964a-4dab-9baa-bc124ef4316b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Medical Center Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "500 W 4th St, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-f93d-7152-a7c7-90ca03be89bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-f93d-7152-a7c7-90ca03be89bd",
        "storage_key": "property/6767906449167164/01a0d98d-f93d-7152-a7c7-90ca03be89bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mchodessa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11779451212487916624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-center-hospital",
      "poi_latitude": "31.84494179999999",
      "poi_longitude": "-102.3738967",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-640-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bb2d-73bf-8dcc-ba26bb06a65b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bb2d-73bf-8dcc-ba26bb06a65b",
        "storage_key": "property/6767906449167164/019d021a-bb2d-73bf-8dcc-ba26bb06a65b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXhoSGHJ-4YRUPxisXcEeaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_53bce5e3-ccc4-4b0c-bcfd-896d77b1970d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Odessa Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "520 E 6th St, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98e-23cb-77e2-a483-4a8dd09d1b1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98e-23cb-77e2-a483-4a8dd09d1b1b",
        "storage_key": "property/6767906449167164/01a0d98e-23cb-77e2-a483-4a8dd09d1b1b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.odessaregionalmedicalcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15794145150316007758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odessa-regional-medical-center",
      "poi_latitude": "31.8522743",
      "poi_longitude": "-102.3638212",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-582-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bb2d-73bf-8dcc-ba26bb06a65b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bb2d-73bf-8dcc-ba26bb06a65b",
        "storage_key": "property/6767906449167164/019d021a-bb2d-73bf-8dcc-ba26bb06a65b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTtAlFzJ-4YRTlGLT1UTMNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_6374d44d-da33-4647-9dbb-3b2a917f2c74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "500 E 4th St, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9eb8-71e9-ac20-cabbdc2c2a46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9eb8-71e9-ac20-cabbdc2c2a46",
        "storage_key": "property/6767906449167164/01a0d98f-9eb8-71e9-ac20-cabbdc2c2a46.webp",
        "width": 728,
        "height": 351
      },
      "poi_business_url": "https://www.concentra.com/urgent-care-centers/texas/lubbock/odessa-urgent-care/#nearbylocations_g=31.8495808697%7C-102.3639945841&nearbylocations_o=DistanceMi%2CAscending&nearbylocations_distancemi=20&nearbylocations_DistanceMi=20",
      "poi_directions_map_url": "https://maps.google.com/?cid=12869486861179775508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "31.84944479999999",
      "poi_longitude": "-102.3639765",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-279-1401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTySpDLJ-4YRFGotYh2ambI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_d37df2bc-889d-4443-bedc-547dff69c1f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "MCH Urgent Care JBS Parkway",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 John Ben Shepperd Pkwy, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9da4-761b-a305-c392c1552f5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9da4-761b-a305-c392c1552f5e",
        "storage_key": "property/6767906449167164/01a0d98f-9da4-761b-a305-c392c1552f5e.webp",
        "width": 830,
        "height": 415
      },
      "poi_business_url": "https://www.mchodessa.com/services/mch-urgent-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1051829950211322003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mch-urgent-care-jbs-parkway",
      "poi_latitude": "31.8843383",
      "poi_longitude": "-102.3317184",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-640-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOduw3sHO-4YRk3B2UsTZmA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8d165156-ad96-4c9c-9403-20131669448b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "801 Maple Ave, Odessa, TX 79761, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-6218-74ba-8bc1-d1a3a1985dfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-6218-74ba-8bc1-d1a3a1985dfd",
        "storage_key": "property/6767906449167164/019d021a-6218-74ba-8bc1-d1a3a1985dfd.webp",
        "width": 1259,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-801+maple+ave-odessa-tx-79761/id=7024",
      "poi_directions_map_url": "https://maps.google.com/?cid=402140117967948728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "31.8583649",
      "poi_longitude": "-102.3591172",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-337-6637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b70c-73e0-82a2-3ed6ac4f01c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b70c-73e0-82a2-3ed6ac4f01c7",
        "storage_key": "property/6767906449167164/019d021a-b70c-73e0-82a2-3ed6ac4f01c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc1-DCkbJ-4YRuMtpgU6wlAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_29c5e6f7-d974-48e9-8bc9-3e926c1ca8c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Town & Country Drug",
      "poi_type": "Health and Wellness",
      "poi_address": "2616 N Grandview Ave, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-9ffa-72dd-937e-313f6d382b7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-9ffa-72dd-937e-313f6d382b7b",
        "storage_key": "property/6767906449167164/01a0d98f-9ffa-72dd-937e-313f6d382b7b.webp",
        "width": 718,
        "height": 540
      },
      "poi_business_url": "https://tcdpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2867625479124091485&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town--country-drug",
      "poi_latitude": "31.8753194",
      "poi_longitude": "-102.3462082",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-366-2868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b70c-73e0-82a2-3ed6ac4f01c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b70c-73e0-82a2-3ed6ac4f01c7",
        "storage_key": "property/6767906449167164/019d021a-b70c-73e0-82a2-3ed6ac4f01c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfjEoDLJ-4YRXQINEC7ayyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_39e33e9f-027d-4580-972d-f7478607c8b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1355 W University Blvd, Odessa, TX 79764, USA",
      "poi_short_description": "Gym chain providing a variety of exercise equipment, massage chairs, and tanning services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-92ad-71ec-808c-eb6e223c041c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-92ad-71ec-808c-eb6e223c041c",
        "storage_key": "property/6767906449167164/019d021a-92ad-71ec-808c-eb6e223c041c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/odessa-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18178379114148333317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.862919",
      "poi_longitude": "-102.398221",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-333-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJccb-5qPJ-4YRBQcxu32TRvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_48347186-a0ca-406d-82aa-10264fe76b50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Crunch Fitness - Odessa",
      "poi_type": "Health and Wellness",
      "poi_address": "2008 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Relaxed, family-focused chain offers a variety of fitness classes, plus equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-ebf6-7799-8936-1d0824944e72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-ebf6-7799-8936-1d0824944e72",
        "storage_key": "property/6767906449167164/01a0d98d-ebf6-7799-8936-1d0824944e72.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.crunch.com/locations/odessa",
      "poi_directions_map_url": "https://maps.google.com/?cid=10724134956650516741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---odessa",
      "poi_latitude": "31.8879306",
      "poi_longitude": "-102.3533229",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-305-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc_MtjrJ-4YRBdGAluzH05Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_072cb8cf-9a96-4194-8a6e-0e025fe8df15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "rOming Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "3952 E 42nd St I, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-8f4a-77bc-a244-66308c721254.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-8f4a-77bc-a244-66308c721254",
        "storage_key": "property/6767906449167164/019d021a-8f4a-77bc-a244-66308c721254.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.romingyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1742308224925134235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roming-yoga",
      "poi_latitude": "31.8897804",
      "poi_longitude": "-102.3462088",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-880-7075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtz9e-PDP-4YRm23ncxnsLRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_8f18bfdd-ec59-432f-a355-c5920405ee1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Noël Heritage Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "301 W 5th St, Odessa, TX 79761, USA",
      "poi_short_description": "Small park with fountains, grassy expanses and sculptures, as well as summer concerts and Friday shows.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-a50a-707a-822c-9067d4878047.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-a50a-707a-822c-9067d4878047",
        "storage_key": "property/6767906449167164/01a0d98f-a50a-707a-822c-9067d4878047.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://odessaarts.org/venue/noel-heritage-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12838446987706115407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nol-heritage-plaza",
      "poi_latitude": "31.8464513",
      "poi_longitude": "-102.3717033",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJawIZL2fJ-4YRTyXoqYNTK7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4feafa06-51b9-40f5-8158-fa74e6c4f0fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Purple Sage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "615 E 11th St, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.odessa-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13283281736492450535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "purple-sage-park",
      "poi_latitude": "31.8572401",
      "poi_longitude": "-102.3679256",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0G6F0LJ-4YR5wIRi1yyV7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c343c139-0e2d-4137-9ca2-ad2ef8956d83",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Progressive Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "610 N Tom Green Ave, Odessa, TX 79761, USA",
      "poi_short_description": "Park featuring a playground with swings and slides, perfect for small children.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-aa17-7409-a593-753fc1ed9850.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-aa17-7409-a593-753fc1ed9850",
        "storage_key": "property/6767906449167164/01a0d98f-aa17-7409-a593-753fc1ed9850.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15273115080348266393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "progressive-park",
      "poi_latitude": "31.8522617",
      "poi_longitude": "-102.3656019",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC0RgkNfJ-4YRme_RwT4B9dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b91efd6d-0293-4a6e-9059-acead754a305",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Woodson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1010 Martin Luther King, Jr. St, Odessa, TX 79761, USA",
      "poi_short_description": "Relaxed park with a playground, a swimming pool and a basketball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-a6f8-7168-8404-6f222bc39b8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-a6f8-7168-8404-6f222bc39b8a",
        "storage_key": "property/6767906449167164/01a0d98f-a6f8-7168-8404-6f222bc39b8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9775331579759261237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodson-park",
      "poi_latitude": "31.8435169",
      "poi_longitude": "-102.3509335",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbgjk97J-4YRNXY1pUf0qIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a7b8a22f-750e-4ebd-abd8-000613cec4f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Memorial Garden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4730 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-a6a2-7471-bdbe-9692e8a1faed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-a6a2-7471-bdbe-9692e8a1faed",
        "storage_key": "property/6767906449167164/01a0d98f-a6a2-7471-bdbe-9692e8a1faed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14327441946354365754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-garden-park",
      "poi_latitude": "31.891374",
      "poi_longitude": "-102.3368556",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f8wqSnP-4YROrV7SIpM1cY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_05f63a6a-45b4-4ac7-b2d5-60d723e3089e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "McKinney Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 W Pool Rd, Odessa, TX 79763, USA",
      "poi_short_description": "Recreational green space offering a children's water play area, sports courts & picnic facilities.",
      "poi_long_description": "Recreational green space offering a children's water play area, sports courts & picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-9c80-71d1-9b2e-3e0d0dd3150f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-9c80-71d1-9b2e-3e0d0dd3150f",
        "storage_key": "property/6767906449167164/019d021a-9c80-71d1-9b2e-3e0d0dd3150f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.boswellrealtors.com/starbright-village-mckinney-park-odessa-month-december/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5581551082187754560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-park",
      "poi_latitude": "31.8264963",
      "poi_longitude": "-102.3651873",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdesgGenL-4YRQIx_DSOndU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c84651f7-b6f9-4d72-bf22-85939d391914",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Comanche Trail South Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "301 Interstate 20 Service Rd, Odessa, TX 79766, USA",
      "poi_short_description": "Community park featuring a walking/jogging trail, pond stocked with fish & 3 disc-golf courses.",
      "poi_long_description": "Community park featuring a walking/jogging trail, pond stocked with fish & 3 disc-golf courses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-a623-7538-a2be-76db8289d2cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-a623-7538-a2be-76db8289d2cb",
        "storage_key": "property/6767906449167164/01a0d98f-a623-7538-a2be-76db8289d2cb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.odessa-tx.gov/567/Fishing-Comanche-Trail-Pond",
      "poi_directions_map_url": "https://maps.google.com/?cid=13475482745940662300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comanche-trail-south-park",
      "poi_latitude": "31.8255087",
      "poi_longitude": "-102.3599088",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZDm3u3L-4YRHNiySCmIArs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_5c1b0cfc-66b6-4d18-9e43-323c8b6ec8b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Sherwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4819 N Everglade Ave, Odessa, TX 79762, USA",
      "poi_short_description": "Park featuring an outdoor aquatic center & a playground, plus a bike/skate park & baseball.",
      "poi_long_description": "Park featuring an outdoor aquatic center & a playground, plus a bike/skate park & baseball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-fb7c-76a3-9e83-608363d68fb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-fb7c-76a3-9e83-608363d68fb4",
        "storage_key": "property/6767906449167164/01a0d98d-fb7c-76a3-9e83-608363d68fb4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.odessa-tx.gov/540/Facilities-Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3933105874804604259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sherwood-park",
      "poi_latitude": "31.8890956",
      "poi_longitude": "-102.3757178",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJidbAzeHI-4YRY_26Y_QylTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_057a59eb-3a4b-44ff-8e3a-e11cdb027c5e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Slator Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1001 W 38th St, Odessa, TX 79764, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-aa20-7157-9754-8a97e3530fc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-aa20-7157-9754-8a97e3530fc2",
        "storage_key": "property/6767906449167164/01a0d98f-aa20-7157-9754-8a97e3530fc2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17255674319099589774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slator-park",
      "poi_latitude": "31.8745034",
      "poi_longitude": "-102.3966083",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4YeSj8LJ-4YRjvTCZV54eO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_61ae10f6-9ba6-4ec5-a95a-44336b69d06f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Floyd Gwin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1015 N County Rd W, Odessa, TX 79763, USA",
      "poi_short_description": "This 52-acre park features sports fields & courts, a picnic pavilion, a playground & more.",
      "poi_long_description": "This 52-acre park features sports fields & courts, a picnic pavilion, a playground & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-fe59-731b-a418-a84515894c70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-fe59-731b-a418-a84515894c70",
        "storage_key": "property/6767906449167164/01a0d98d-fe59-731b-a418-a84515894c70.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17629771139723470821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "floyd-gwin-park",
      "poi_latitude": "31.8445067",
      "poi_longitude": "-102.3929297",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bafd-7403-9be4-630659b7cb87",
        "storage_key": "property/6767906449167164/019d021a-bafd-7403-9be4-630659b7cb87.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW4TFIoLJ-4YR5aem7nGHqfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2952a62b-eb3b-4077-9e08-946eb872f204",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Midland International Air & Space Port",
      "poi_type": "Transportation & Transit",
      "poi_address": "9506 La Force Blvd, Midland, TX 79706, USA",
      "poi_short_description": "Airport with a terminal housing the 1911 Pliska Aeroplane, the first airplane built in Texas.",
      "poi_long_description": "Airport with a terminal housing the 1911 Pliska Aeroplane, the first airplane built in Texas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-a1db-767c-85f6-cad5ff26d1ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-a1db-767c-85f6-cad5ff26d1ee",
        "storage_key": "property/6767906449167164/019d021a-a1db-767c-85f6-cad5ff26d1ee.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.flymaf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9536195868847421991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-international-air--space-port",
      "poi_latitude": "31.9417386",
      "poi_longitude": "-102.2047497",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 432-560-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bf0e-777a-9154-c7cb43d249cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bf0e-777a-9154-c7cb43d249cf",
        "storage_key": "property/6767906449167164/019d021a-bf0e-777a-9154-c7cb43d249cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQSBGYDQ-4YRJ7oyJ55fV4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_c5f08241-36b9-470a-a16b-0fb5f38d5e1f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Odessa-Schlemeyer Field Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 E Terminal Dr, Odessa, TX 79765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98d-ff8e-755a-a9b5-9c34a328c5a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98d-ff8e-755a-a9b5-9c34a328c5a3",
        "storage_key": "property/6767906449167164/01a0d98d-ff8e-755a-a9b5-9c34a328c5a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.co.ector.tx.us/page/ector.SchlemeyerAirport",
      "poi_directions_map_url": "https://maps.google.com/?cid=3086631053830619427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odessa-schlemeyer-field-airport",
      "poi_latitude": "31.9228471",
      "poi_longitude": "-102.3928078",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 432-367-5881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bf0e-777a-9154-c7cb43d249cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bf0e-777a-9154-c7cb43d249cf",
        "storage_key": "property/6767906449167164/019d021a-bf0e-777a-9154-c7cb43d249cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5BcoobI-4YRI4FD_Jbq1So",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_98a3e7a0-f033-4e3a-a859-659c08cc5caf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "All Aboard America - Midland/Odessa",
      "poi_type": "Transportation & Transit",
      "poi_address": "10615 W County Rd 127, Odessa, TX 79765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-aeb8-7260-9966-c892ef49e993.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-aeb8-7260-9966-c892ef49e993",
        "storage_key": "property/6767906449167164/01a0d98f-aeb8-7260-9966-c892ef49e993.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "http://www.allaboardamerica.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1803141971490925625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "all-aboard-america---midlandodessa",
      "poi_latitude": "31.913411",
      "poi_longitude": "-102.2231014",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-561-8529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSR1k3ETQ-4YROWxQ0hEMBhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_0a1a52c9-0d18-481d-b60b-2976c6afc851",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Staybridge Suites Odessa - Interstate Hwy 20 by IHG",
      "poi_type": "Major Employers & Offices",
      "poi_address": "810 S John Ben Shepperd Pkwy, Odessa, TX 79761, USA",
      "poi_short_description": "Relaxed studios & suites with kitchens in a straightforward hotel offering a gym & an outdoor pool.",
      "poi_long_description": "Relaxed studios & suites with kitchens in a straightforward hotel offering a gym & an outdoor pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-ad0a-7761-b9e5-32c8a0e7b0a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-ad0a-7761-b9e5-32c8a0e7b0a5",
        "storage_key": "property/6767906449167164/01a0d98f-ad0a-7761-b9e5-32c8a0e7b0a5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ihg.com/staybridge/hotels/us/en/odessa/mafod/hoteldetail?cm_mmc=GoogleMaps-_-SB-_-US-_-MAFOD",
      "poi_directions_map_url": "https://maps.google.com/?cid=6212883221006553073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "staybridge-suites-odessa---interstate-hwy-20-by-ihg",
      "poi_latitude": "31.8577673",
      "poi_longitude": "-102.3187061",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-231-4565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bf5e-766a-afa7-6d44eaf53a7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bf5e-766a-afa7-6d44eaf53a7e",
        "storage_key": "property/6767906449167164/019d021a-bf5e-766a-afa7-6d44eaf53a7e.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJjaXMVpfO-4YR8Y8US1-YOFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "extended_stay_hotel"
    },
    {
      "id": "custom_b9c87adb-61ab-47ae-b64b-be11718ddac6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "The University of Texas Permian Basin",
      "poi_type": "Education",
      "poi_address": "4901 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-6d68-77d9-84c9-9d41ff8c6897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-6d68-77d9-84c9-9d41ff8c6897",
        "storage_key": "property/6767906449167164/019d021a-6d68-77d9-84c9-9d41ff8c6897.webp",
        "width": 1280,
        "height": 532
      },
      "poi_business_url": "http://www.utpb.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16037060805297192125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-permian-basin",
      "poi_latitude": "31.8876067",
      "poi_longitude": "-102.3230046",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-552-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs0RSpufO-4YRvTwUndUVj94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4bc99f79-1493-4b4f-b5af-aba9cc790c35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Midland Airpark",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Veterans Airpark Ln, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-aecd-719e-9773-b6bace5e97cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-aecd-719e-9773-b6bace5e97cc",
        "storage_key": "property/6767906449167164/01a0d98f-aecd-719e-9773-b6bace5e97cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flymaf.com/149/Midland-Executive-Airpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=9810408844524569748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-airpark",
      "poi_latitude": "32.0331878",
      "poi_longitude": "-102.0970535",
      "poi_miles_from_property": "19.8",
      "poi_walking_minutes": "7 hours 11 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 432-685-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bf0e-777a-9154-c7cb43d249cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bf0e-777a-9154-c7cb43d249cf",
        "storage_key": "property/6767906449167164/019d021a-bf0e-777a-9154-c7cb43d249cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ4T9cXY-4YRlMQ8x92SJYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_395dbc2b-dda9-4a17-a25e-4c948c3aebb3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Texas Tech University Health Sciences Center at Odessa",
      "poi_type": "Education",
      "poi_address": "800 W 4th St, Odessa, TX 79763, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-b1ad-77bb-abdf-ac6f3fdf3134.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-b1ad-77bb-abdf-ac6f3fdf3134",
        "storage_key": "property/6767906449167164/01a0d98f-b1ad-77bb-abdf-ac6f3fdf3134.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ttuhsc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17725776632681298455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-tech-university-health-sciences-center-at-odessa",
      "poi_latitude": "31.8437384",
      "poi_longitude": "-102.3771382",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-335-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB6LN9mPJ-4YRF3rjpu6b_vU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_4650f7ee-3104-46cc-8fcd-8654ae3cb99c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Ector County Annex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1010 E 8th St, Odessa, TX 79761, USA",
      "poi_short_description": "Voting, birth certificate and passport services are provided at this outpost.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ectorcountytx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14191911653544314105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ector-county-annex",
      "poi_latitude": "31.8556747",
      "poi_longitude": "-102.3614125",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bf64-74ae-be5e-b28cba7336c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bf64-74ae-be5e-b28cba7336c3",
        "storage_key": "property/6767906449167164/019d021a-bf64-74ae-be5e-b28cba7336c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfpMV0TJ-4YR-UQ8-XTM88Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_3d41d742-cef9-40c5-8097-93d7ad5dc22e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Halliburton bulk plant",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6155 W Murphy St, Odessa, TX 79763, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-b2a8-7190-a1ac-90f5976b2ff0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-b2a8-7190-a1ac-90f5976b2ff0",
        "storage_key": "property/6767906449167164/01a0d98f-b2a8-7190-a1ac-90f5976b2ff0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://halliburton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8890155618981110709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "halliburton-bulk-plant",
      "poi_latitude": "31.8078259",
      "poi_longitude": "-102.4360024",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 432-571-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4XAGHbK-4YRteNP824tYHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_21bb6216-0e2e-4e55-baf7-b3bf61dd40f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Schlumberger",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2626 John Ben Shepperd Pkwy, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8523967275672426233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schlumberger",
      "poi_latitude": "31.8778616",
      "poi_longitude": "-102.3283577",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-550-3719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b738-705e-95c6-89d24fae3544",
        "storage_key": "property/6767906449167164/019d021a-b738-705e-95c6-89d24fae3544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-0zVMPO-4YR-VaCRxM3S3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_60d76059-0713-4c51-9b00-350be05c0c7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Ector County Independent School District",
      "poi_type": "Education",
      "poi_address": "802 N Sam Houston Ave, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-b5e7-775c-9903-539ac38e7a49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-b5e7-775c-9903-539ac38e7a49",
        "storage_key": "property/6767906449167164/01a0d98f-b5e7-775c-9903-539ac38e7a49.webp",
        "width": 1280,
        "height": 1278
      },
      "poi_business_url": "https://www.ectorcountyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=441067703295732504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ector-county-independent-school-district",
      "poi_latitude": "31.8505701",
      "poi_longitude": "-102.3735318",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-456-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-b730-76ff-883d-92a99c945e85",
        "storage_key": "property/6767906449167164/019d021a-b730-76ff-883d-92a99c945e85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyetFPWbJ-4YRGOvWQL38HgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6084a208-08aa-42c3-9d4b-5ecd1a8dd02e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "poi_name": "Odessa Texas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "411 W 8th St, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a0d98f-b14c-763b-aec5-d31753d465e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0d98f-b14c-763b-aec5-d31753d465e5",
        "storage_key": "property/6767906449167164/01a0d98f-b14c-763b-aec5-d31753d465e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.odessa-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12723819046806654763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odessa-texas-city-hall",
      "poi_latitude": "31.8489889",
      "poi_longitude": "-102.3750505",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-335-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-bf64-74ae-be5e-b28cba7336c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bf64-74ae-be5e-b28cba7336c3",
        "storage_key": "property/6767906449167164/019d021a-bf64-74ae-be5e-b28cba7336c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVnXeGbJ-4YRK49CZwIWlLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9c580a722e666604f9de6882",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c4046dfee091e5c5fa5c08af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_aba353045b8465f512cf52d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d1dbea6a537da31c7e1ab8e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_af20ae4158b601ba0bc77255",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d0992df1a74e3b645634a9d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_baea3bc020ad1b9b365eb3d3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "rating": "5",
      "name": "America Baltierrez",
      "text": "I am very grateful for this apartment complex. The staff is the sweetest. Monique Patterson and Susana were the absolute most welcoming and kindest ladies ever. They made applying and moving  in sooo smooth. I absolutely recommend for you to apply if you’re looking for a great place to stay!",
      "date": "2025-02-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8fce08e3-70fa-4da8-8187-dfb4313997f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019ddcf7-ac83-71d8-837c-403469f4b19d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf7-ac83-71d8-837c-403469f4b19d",
        "storage_key": "property/6767906449167164/019ddcf7-ac83-71d8-837c-403469f4b19d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1x1 648 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=t7QQcm33xuU"
    },
    {
      "id": "custom_08b382a0-784f-4d5e-aed3-cf4182ec1870",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019ddcf7-ad3d-71df-91e0-7ce7e82b1a41.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf7-ad3d-71df-91e0-7ce7e82b1a41",
        "storage_key": "property/6767906449167164/019ddcf7-ad3d-71df-91e0-7ce7e82b1a41.webp",
        "width": 295,
        "height": 166
      },
      "virtual_tour_title": "2x1 802 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/833351666?h=7e913ac3ba&badge=0&autopause=0&player_id=0&app_id=58479"
    },
    {
      "id": "custom_06a4b2a9-0899-45d6-8a39-725b32457ad4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019ddcf7-ad28-74c1-af0c-142717b08e8e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf7-ad28-74c1-af0c-142717b08e8e",
        "storage_key": "property/6767906449167164/019ddcf7-ad28-74c1-af0c-142717b08e8e.webp",
        "width": 200,
        "height": 150
      },
      "virtual_tour_title": "2x2 867 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/726174575?h=fcbd0ec241"
    },
    {
      "id": "custom_49ca7aa8-3223-484b-a26d-d230ca196da1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/01a15b82-4074-775e-a4c6-4a59ae20c959.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a15b82-4074-775e-a4c6-4a59ae20c959",
        "storage_key": "property/6767906449167164/01a15b82-4074-775e-a4c6-4a59ae20c959.webp",
        "width": 200,
        "height": 150
      },
      "virtual_tour_title": "1x1 - 530 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/805180921?h=9cb2730416"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d0ba-7510-8b36-ee3f430c154d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Acacia Park Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "outdoor-pool-apartments-odessa-tx-acacia-park",
      "search_query": "outdoor pool apartments odessa tx",
      "category": "Amenity",
      "h1_title": "Outdoor Pool Apartments in Odessa, TX",
      "h2_subtitle": "Discover Odessa, TX apartments with an outdoor pool. Acacia Park offers a refreshing lifestyle with top-notch amenities to enjoy every day.",
      "page_copy": "At Acacia Park, we know the value of enjoying leisure time right at home. Nestled in Odessa, TX, our apartments boast an inviting outdoor pool, perfect for those sunny Texas days. Whether you're looking to relax poolside or take a refreshing dip, our pool area is a great spot to unwind or socialize with neighbors.\n\nOur community offers more than just an outdoor pool; each apartment features modern conveniences like walk-in closets and granite kitchen countertops. With a built-in office/desk, you can efficiently work from home. Plus, enjoy coffee on your patio or balcony overlooking the beautiful landscaped grounds. Discover the blend of comfort and outdoor recreation at Acacia Park, the ideal lifestyle choice in Odessa, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Outdoor Pool Apartments in Odessa, TX",
      "seo_description": "Discover Acacia Park's Odessa, TX apartments with an outdoor pool, offering top amenities like granite countertops and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "granite-kitchen-countertops-ector-county-acacia-park",
      "search_query": "granite kitchen countertops ector county",
      "category": "Amenity",
      "h1_title": "Granite Kitchen Countertops in Ector County",
      "h2_subtitle": "Explore luxury living with granite kitchen countertops. Acacia Park in Ector County offers stylish and functional apartments to enhance your lifestyle.",
      "page_copy": "Acacia Park, situated in the heart of Ector County, offers residences that exemplify luxury and style. A standout feature of our apartments is the stunning granite kitchen countertops. These countertops not only provide a sleek, modern look but are also highly durable, making them an ideal choice for both avid cooks and those who appreciate beautiful design.\n\nBeyond elegant kitchens, residents enjoy spacious walk-in closets, private patios or balconies, and a refreshing outdoor pool. Our built-in office desks cater to remote work needs, rounding out a perfect living experience. At Acacia Park, you're not just renting an apartment; you're finding a home that harmonizes luxury with utility, situated conveniently in Ector County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Kitchen Countertops in Ector County",
      "seo_description": "Discover Acacia Park in Ector County with granite kitchen countertops, walk-in closets, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "walk-in-closet-apartments-near-79761-acacia-park",
      "search_query": "walk-in closet apartments near 79761",
      "category": "Amenity",
      "h1_title": "Walk-In Closet Apartments Near 79761",
      "h2_subtitle": "Find spacious apartments near 79761 with walk-in closets. Acacia Park offers abundant storage and stylish living in a prime Odessa location.",
      "page_copy": "Located conveniently near the 79761 area, Acacia Park offers apartments with spacious walk-in closets, providing ample storage space for all your needs. Each apartment is designed with practicality and style in mind, ensuring you have room to organize and display your wardrobe with ease.\n\nIn addition to generous storage, enjoy the luxury of granite kitchen countertops and the versatility of a built-in office/desk, perfect for working or studying from home. Relax by the outdoor pool or unwind on your private patio or balcony. Acacia Park combines modern amenities and a superb location, making it an ideal choice for those seeking comfortable and stylish living near 79761.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closet Apartments Near 79761",
      "seo_description": "Explore Acacia Park near 79761, featuring walk-in closet apartments with granite countertops and an outdoor pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "central-ac-heating-apartment-odessa-acacia-park",
      "search_query": "central ac heating available apartment odessa",
      "category": "Amenity",
      "h1_title": "Central AC & Heating Apartments in Odessa",
      "h2_subtitle": "Enjoy year-round comfort in Odessa with central AC and heating. Acacia Park ensures a cozy living experience with modern amenities.",
      "page_copy": "At Acacia Park, we prioritize comfort with each of our Odessa apartments featuring central AC and heating. This ensures a pleasant, consistent indoor climate no matter the Texas weather. Whether it’s sweltering heat or a rare chilly night, you’ll feel right at home with the perfect temperature year-round.\n\nAlongside climate control, our community offers stunning amenities such as granite kitchen countertops and private patios or balconies. Unwind at our outdoor pool, and benefit from built-in office/desks ideal for remote work or study. Acacia Park combines convenience and comfort in every unit, providing a superior living experience in Odessa.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Central AC & Heating Apartments in Odessa",
      "seo_description": "Discover Acacia Park in Odessa with central AC and heating, offering modern amenities like granite countertops and walk-in closets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "on-site-management-maintenance-ector-county-acacia-park",
      "search_query": "on-site management and maintenance ector county",
      "category": "Amenity",
      "h1_title": "On-Site Management & Maintenance in Ector County",
      "h2_subtitle": "Experience superior service with on-site management and maintenance. Acacia Park ensures hassle-free living in Ector County.",
      "page_copy": "Acacia Park in Ector County provides residents with reliable on-site management and maintenance services. Our dedicated team is always on-hand to address any concerns or repairs, ensuring that living at Acacia Park is as convenient as possible. This commitment to excellence ensures that our residents can enjoy their home without worry.\n\nIn addition to top-notch services, the community boasts beautiful amenities, including granite kitchen countertops and spacious walk-in closets. Relax on your private patio or balcony, or enjoy the outdoor pool for leisure and recreation. Acacia Park offers a blend of comfort, style, and attentive service, creating an ideal living environment in Ector County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "On-Site Management & Maintenance in Ector County",
      "seo_description": "Acacia Park offers on-site management and maintenance in Ector County, ensuring convenient, hassle-free living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-odessa-tx-acacia-park",
      "search_query": "one bedroom apartments odessa tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Odessa, TX",
      "h2_subtitle": "Discover cozy one bedroom apartments in Odessa, TX. Acacia Park offers stylish homes with modern amenities for comfortable living.",
      "page_copy": "At Acacia Park, our one bedroom apartments in Odessa, TX are designed with your lifestyle in mind. Featuring modern aesthetics and practical layouts, each unit offers granite kitchen countertops complemented by spacious interiors. Enjoy the convenience of a built-in office/desk, perfect for remote work or personal projects.\n\nRelax on your private patio or balcony, or take a dip in the inviting outdoor pool. Our community is known for its commitment to comfort and style, providing you with a home that's both functional and welcoming. Experience the perfect blend of amenities and location at Acacia Park, where Odessa's vibrant city life is right at your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Odessa, TX",
      "seo_description": "Explore Acacia Park's one bedroom apartments in Odessa, TX with modern amenities like granite countertops and private patios.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-ector-county-acacia-park",
      "search_query": "two bedroom apartments ector county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Ector County",
      "h2_subtitle": "Find spacious two bedroom apartments in Ector County at Acacia Park. Discover modern living in a vibrant community.",
      "page_copy": "Acacia Park offers premium two bedroom apartments in Ector County, perfect for those seeking ample space and comfort. Each apartment comes with stylish granite kitchen countertops and sleek, practical designs that cater to modern living needs. With walk-in closets and a built-in office/desk, our layouts maximize functionality and comfort.\n\nResidents enjoy private patios or balconies, perfect for relaxation, along with access to a refreshing outdoor pool ideal for leisure. Our on-site management and maintenance teams are dedicated to providing a hassle-free living experience, making Acacia Park an attractive choice for those looking to settle in Ector County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Ector County",
      "seo_description": "Discover Acacia Park's spacious two bedroom apartments in Ector County, featuring modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "apartments-near-university-texas-permian-basin",
      "search_query": "apartments near the university of texas permian basin odessa",
      "category": "School",
      "h1_title": "Apartments Near University of Texas Permian Basin",
      "h2_subtitle": "Stay close to campus with our apartments near the University of Texas Permian Basin in Odessa. Enjoy convenient and modern living at Acacia Park.",
      "page_copy": "Located conveniently near the University of Texas Permian Basin in Odessa, Acacia Park offers ideal apartments for students, faculty, and staff. Our spacious units feature modern amenities such as granite kitchen countertops and walk-in closets, providing a comfortable and stylish living environment.\n\nThe property includes a range of amenities to enhance your living experience, from a refreshing outdoor pool to patios/balconies perfect for relaxation. With a built-in office/desk available in select units, you'll find the perfect balance between work and leisure. Choose Acacia Park for community living near academia, where convenience meets quality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Texas Permian Basin",
      "seo_description": "Explore Acacia Park's apartments near the University of Texas Permian Basin, offering modern amenities and convenient access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "apartments-close-to-odessa-college-ector-county",
      "search_query": "apartments close to odessa college ector county",
      "category": "School",
      "h1_title": "Apartments Close to Odessa College",
      "h2_subtitle": "Find your new home with our apartments close to Odessa College in Ector County. Enjoy convenience and exceptional amenities at Acacia Park.",
      "page_copy": "For those seeking quality living near Odessa College in Ector County, Acacia Park provides the perfect solution. Our community offers modern apartments that feature granite kitchen countertops and spacious walk-in closets, ensuring a comfortable and stylish environment.\n\nResidents have access to great amenities, including a refreshing outdoor pool and private patios or balconies, enhancing your lifestyle. The built-in office/desk in select units is perfect for students and professionals alike. Choose Acacia Park for a vibrant community experience with convenient access to Odessa College, making it easier than ever to balance work, study, and relaxation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Odessa College, Ector County",
      "seo_description": "Discover Acacia Park's modern apartments close to Odessa College in Ector County, featuring excellent amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167164",
      "source": "generator",
      "page_item_url": "apartments-near-medical-center-hospital-odessa",
      "search_query": "apartments near Medical Center Hospital Odessa TX",
      "category": "Hospital",
      "h1_title": "Apartments Near Medical Center Hospital",
      "h2_subtitle": "Discover comfortable living in our apartments near Medical Center Hospital in Odessa, TX. Enjoy convenience and modern amenities at Acacia Park.",
      "page_copy": "At Acacia Park, we offer vibrant community living just minutes from Medical Center Hospital in Odessa, TX. Our apartments are designed with functionality and style in mind, featuring walk-in closets and contemporary granite kitchen countertops that make everyday living convenient and luxurious.\n\nEnjoy our on-site amenities like the outdoor pool and private patios or balconies, perfect for unwinding after a busy day at the hospital. Select units also include a built-in office/desk, catering to those who need a designated workspace at home. Experience the perfect balance of proximity and privacy here at Acacia Park, ideal for healthcare professionals and hospital staff.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Medical Center Hospital, Odessa TX",
      "seo_description": "Explore modern amenities and convenience at Acacia Park, located near Medical Center Hospital, Odessa, TX, offering unique advantages for professional living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5141"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309322043"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4322183063"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "0e3419d9-24b2-4bc1-95ad-48518903397f"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/f2837736-5f4b-4e4a-9d2b-85f205dc700f/app.js?property=f2837736-5f4b-4e4a-9d2b-85f205dc700f&propertyName=Acacia+Park&channelUuid=c248f7c7-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47606143147"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlNBZ3RIVnI4QkRzaVBTVHhMMk9xb3c9PSIsInZhbHVlIjoiU2pxdU53bUQ1YitBQ1o5eVFzRTlLdz09IiwibWFjIjoiOTc0Y2Y4M2Y4MDRlZDI1MjVjNzI3ODhkYjgxYmZjMTllZWYzYzc1MTExNzcwZDg4NjNlZDA1MzVhNGRiZTAxYyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "5141",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309322043",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4322183063",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "0e3419d9-24b2-4bc1-95ad-48518903397f",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/f2837736-5f4b-4e4a-9d2b-85f205dc700f/app.js?property=f2837736-5f4b-4e4a-9d2b-85f205dc700f&propertyName=Acacia+Park&channelUuid=c248f7c7-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47606143147",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlNBZ3RIVnI4QkRzaVBTVHhMMk9xb3c9PSIsInZhbHVlIjoiU2pxdU53bUQ1YitBQ1o5eVFzRTlLdz09IiwibWFjIjoiOTc0Y2Y4M2Y4MDRlZDI1MjVjNzI3ODhkYjgxYmZjMTllZWYzYzc1MTExNzcwZDg4NjNlZDA1MzVhNGRiZTAxYyJ9",
  "custom_audioeye_site_id": "32f666db-93df-41ee-9841-356397faca5d",
  "custom_audioeye_site_hash": "bf5074d0b21ade192a467e92cbfb5a6c"
};

export const generatedAt = '2026-11-02T18:12:31.142Z';
